import { render, staticRenderFns } from "./EmpData.vue?vue&type=template&id=e81bc712&scoped=true&"
import script from "./EmpData.vue?vue&type=script&lang=js&"
export * from "./EmpData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81bc712",
  null
  
)

export default component.exports